import {
  Component, Input, OnChanges, OnDestroy, ViewEncapsulation,
  ElementRef, AfterViewInit, HostBinding, inject,
} from '@angular/core';
import { DonutVm } from '../tableau-de-bord.types';
import * as Chartist from 'chartist';

/**
 * Un anneau Chartist. Les classes ct-chartD/graphD (grand anneau) ou
 * ct-chartE/graphE (badge %) sont portees par l'element HOTE : le CSS legacy
 * cible .b2 > .graphD (enfant direct) et positionne chaque anneau selon sa
 * place exacte dans le DOM du bloc b2 — le composant doit donc etre insere
 * la ou le div legacy se trouvait, sans div intermediaire.
 */
@Component({
  selector: 'app-dashboard-donuts',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  template: '',
})
export class DashboardDonutsComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() donut: DonutVm = { d1: 0, d2: 1 };
  @Input() variant: 'D' | 'E' = 'D';

  @HostBinding('class') get hostClass(): string {
    return `ct-chart${this.variant} graph${this.variant}`;
  }

  // L'hote remplace le <div> legacy : il doit se comporter comme un bloc
  // pour que height/width/margins du CSS .graphD/.graphE s'appliquent.
  @HostBinding('style.display') readonly display = 'block';

  private readonly el = inject(ElementRef<HTMLElement>);
  private chart: Chartist.PieChart | null = null;

  ngAfterViewInit(): void {
    // Iso legacy : creation avec la serie vide [0, 1] puis update() a chaque
    // changement — c'est l'update qui anime le remplissage de l'anneau.
    this.chart = new Chartist.PieChart(
      this.el.nativeElement,
      { series: [{ value: 0, className: 'd1' }, { value: 1, className: 'd2' }] },
      { donut: true, showLabel: false }
    );
    this.update();
  }

  ngOnChanges(): void {
    this.update();
  }

  ngOnDestroy(): void {
    this.chart?.detach();
    this.chart = null;
  }

  private update(): void {
    this.chart?.update({
      series: [
        { value: this.donut.d1, className: 'd1' },
        { value: this.donut.d2, className: 'd2' },
      ],
    });
  }
}
